import { useLanguage } from "../context/LanguageContext";

export default function Marquee() {
  const { t } = useLanguage();
  const items = t.marquee;

  const row = (hidden) => (
    <div aria-hidden={hidden || undefined} className="flex items-center shrink-0">
      {items.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="px-8 lg:px-12 font-display text-lg lg:text-2xl uppercase tracking-tight text-slate-300 whitespace-nowrap">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/80" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="marquee-section" className="marquee relative overflow-hidden border-y border-white/10 bg-[#0a0b0e] py-5">
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
